import React, { useState, useRef } from "react";
import "./LabTestForm.css";
import axios from "axios";
import { motion } from "framer-motion";
import Webcam from "react-webcam";
import gif from '../../Assets/Banner/whatsapp.gif';
import {
  FaTimes,
  FaCamera,
  FaUpload,
  FaUser,
  FaPhone,
  FaEnvelope,
  FaFlask,
  FaWhatsapp,
} from "react-icons/fa";
import { MdOutlineAddAPhoto } from "react-icons/md";
import { BiSend } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const LabTestForm = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [stream, setStream] = useState(null);
  const [showCamera, setShowCamera] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const videoRef = useRef(null);
  const fileInputRef = useRef(null);
  const webcamRef = useRef(null);
  const navigate = useNavigate();

  const whatsappNumber = "9118063939";

  const startCamera = () => {
    setShowCamera(true);
  };

  const stopCamera = () => {
    setShowCamera(false);
  };

  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      fetch(imageSrc)
        .then((res) => res.blob())
        .then((blob) => {
          const file = new File([blob], "camera-capture.jpg", {
            type: "image/jpeg",
          });
          setImage(file);
          setPreviewUrl(imageSrc);
          stopCamera();
        });
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const removeImage = () => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setImage(null);
    setPreviewUrl("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const shareOnWhatsApp = () => {
    if (!image) {
      setError("Please upload a lab test image first");
      return;
    }

    let whatsappUrl = `https://wa.me/${whatsappNumber}`;
    const message = `New Lab Test Upload\nName: ${name || 'Not provided'}\nPhone: ${phone || 'Not provided'}`;
    whatsappUrl += `?text=${encodeURIComponent(message)}`;
    
    window.open(whatsappUrl, '_blank');
    setSuccess("Opening WhatsApp... Please attach the lab test image manually");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    if (!image) {
      setError("Please upload a lab test image");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("phone", phone);
    formData.append("image", image);

    try {
      console.log("Uploading lab test..."); // Debug log
      const response = await axios.post(
        "https://api.swasthmitra.com/api/labtest/add",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Upload response:", response.data); // Debug log

      if (response.data.success) {
        setSuccess("Lab test uploaded successfully!");
        setName("");
        setPhone("");
        setImage(null);
        setPreviewUrl("");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        setError(response.data.message || "Failed to upload lab test");
      }
    } catch (err) {
      console.error("Upload error:", err.response || err);
      setError(
        err.response?.data?.message ||
          err.message ||
          "Failed to upload lab test"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    navigate("/");
  };

  const videoConstraints = {
    width: 720,
    height: 480,
    facingMode: "environment",
  };

  return (
    <motion.div
      className="lab-test-form"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="modal-overlay">
        <motion.div
          className="modal-content"
          initial={{ scale: 0.95, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
        >
          <motion.button
            className="close-btn1"
            onClick={handleClose}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            X
          </motion.button>

          <div className="form-header">
            <motion.h2
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.1 }}
            >
              <span style={{fontWeight:'bold',fontFamily:'Poppins,sans-serif'}}>"जांच के लिए डॉक्टर की पर्ची यहाँ अपलोड करें"</span>
            </motion.h2>
            <motion.p
              initial={{ y: -10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
            >
              <span style={{fontSize:'13px', color:'black',fontWeight:'600' }}>( What's App / Camera  </span>
              <span style={{fontSize:'13px', color:'black' }}>आइकन पर क्लिक करें, डॉक्टर की पर्ची की साफ़ फोटो लें, नाम व मोबाइल नंबर भरें और फॉर्म सबमिट करें - हमारे प्रतिनिधि तुरंत आपसे संपर्क करेंगे।)</span>
            </motion.p>
          </div>

          {error && (
            <motion.div
              className="alert error"
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
            >
              <FaTimes /> {error}
            </motion.div>
          )}

          {success && (
            <motion.div
              className="alert success"
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
            >
              <FaFlask /> {success}
            </motion.div>
          )}

          <div className="whats-icon">
            <a
              href="https://wa.me/7007512120"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#C22928", textDecoration: "none" }}
            >
              <img className="whatsapp_img" src={gif} alt="WhatsApp" />
            </a>
          </div>

          <form onSubmit={handleSubmit}>
            <motion.div
              className="image-upload-section"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
            >
              {!previewUrl && !showCamera && (
                <motion.div
                  className="upload-container"
                  whileHover={{ scale: 1.01, borderColor: "#6366f1" }}
                >
                  <div className="">
                    <motion.div
                      className="hong"
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <label htmlFor="file-upload" style={{ marginTop:'0px' }} className="upload-here">
                        <span style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'10px'}}><FaCamera /> Upload Here</span>
                      </label>
                      <input
                        id="file-upload"
                        type="file"
                        onChange={handleFileChange}
                        accept="image/*,.pdf"
                        ref={fileInputRef}
                        className="file-input"
                      />
                    </motion.div>
                  </div>
                </motion.div>
              )}

              {showCamera && (
                <div className="camera-container">
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    videoConstraints={videoConstraints}
                    className="camera-preview"
                  />
                  <motion.button
                    type="button"
                    className="capture-btn"
                    onClick={captureImage}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <MdOutlineAddAPhoto /> Capture Photo
                  </motion.button>
                  <motion.button
                    type="button"
                    className="cancel-btn"
                    onClick={stopCamera}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <FaTimes /> Cancel
                  </motion.button>
                </div>
              )}

              {previewUrl && (
                <motion.div
                  className="image-preview"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                >
                  <img src={previewUrl} alt="Preview" />
                  <motion.button
                    type="button"
                    className="remove-image"
                    onClick={removeImage}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    X
                  </motion.button>
                  
                </motion.div>
              )}
            </motion.div>

            <motion.div
              className="form-fields"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
            >
              <div className="input-group">
                <FaUser className="input-icon" />
                <input
                  type="text"
                  placeholder="Your Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <FaPhone className="input-icon" />
                <input
                  type="tel"
                  placeholder="Phone Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
            </motion.div>

            <motion.button
              type="submit"
              className="submit-btn"
              disabled={loading}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
            >
              {loading ? (
                <div className="loading-spinner" />
              ) : (
                <>
                  Submit
                </>
              )}
            </motion.button>
          </form>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default LabTestForm;
